import React from "react";
import { Helmet } from "react-helmet";
import { Header, Titulo } from "./../elementos/Header";
import BtnRegresar from "./../elementos/BtnRegresar";
import BarraTotalGastado from "./BarraTotalGastado";
import FormularioGasto from "./FormularioGasto";
 //recuperamos el id de la barra de navegacion
import { useParams } from "react-router-dom";
import useObtenerGasto from "./../hooks/useObtenerGasto";

const EditarGasto = () => {
  //recuperamos el id de la barra de navegacion
  const { id } = useParams();
  //hook para editar gasto de useObtenerGasto
  const [gasto] = useObtenerGasto(id);
  //console.log(gasto);

  return (
    <>
      <Helmet>
        <title>Gastos por Categoría</title>
      </Helmet>

      <Header>
        <BtnRegresar ruta="/lista" />
        <Titulo>Editar Categoría</Titulo>
      </Header>

      <FormularioGasto gasto={gasto} />

      <BarraTotalGastado />
    </>
  );
};

export default EditarGasto;
